import moment from 'moment';
import { TFunction } from 'react-i18next';
import * as api from '../api';

export const isAppointmentCancellableNow = (
  appointment: api.NotificationIntent.Appointment,
): boolean => {
  const { previsitConfirmCancelMinimumCancelTime } = appointment.preferences;
  if (!appointment.isCancellable) return false;
  if (!previsitConfirmCancelMinimumCancelTime) return true;

  return moment()
    .add(
      previsitConfirmCancelMinimumCancelTime.time,
      api.PracticePreference.TimeUnitToMomentUnit[
        previsitConfirmCancelMinimumCancelTime.unit
      ],
    )
    .isBefore(appointment.encounter.startTime);
};

export const getCancelTimeWindow = (
  appointment: api.NotificationIntent.Appointment,
  t: TFunction,
) => {
  const { previsitConfirmCancelMinimumCancelTime } = appointment.preferences;
  if (!previsitConfirmCancelMinimumCancelTime) return '';
  const { time, unit } = previsitConfirmCancelMinimumCancelTime;
  const formattedUnit = t(
    (time === 1 ? unit.slice(0, -1) : unit).toLowerCase(),
  );

  return `${time} ${formattedUnit}`;
};
